var _circle, _line, _circle2, _path, _rect, _rect2, _rect3, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorruption(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.978,
    cy: 204.858,
    r: 29.2767,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.702 424.433C278.702 416.669 281.786 409.222 287.277 403.732C292.767 398.241 300.214 395.157 307.978 395.157C315.743 395.157 323.19 398.241 328.68 403.732C334.171 409.222 337.255 416.669 337.255 424.433L307.978 424.433L278.702 424.433Z",
    fill: "#FCFCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 293.34,
    y: 190.22,
    width: 29.2767,
    height: 234.214,
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 444.732,
    y: 161.706,
    width: 29.2767,
    height: 289.313,
    rx: 1,
    transform: "rotate(78.346 444.732 161.706)",
    fill: "#FCFCFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 425.085,
    y: 424.434,
    width: 29.2767,
    height: 234.214,
    transform: "rotate(90 425.085 424.434)",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.509 219.497L264.063 336.603H146.956L205.509 219.497ZM246.913 378.007C257.894 367.026 264.063 352.133 264.063 336.604H205.509L146.956 336.604C146.956 352.133 153.125 367.026 164.106 378.007C175.087 388.988 189.98 395.157 205.509 395.157C221.039 395.157 235.932 388.988 246.913 378.007Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M410.447 175.582L469 292.688H351.893L410.447 175.582ZM451.85 334.092C462.831 323.111 469 308.218 469 292.689H410.446L351.893 292.689C351.893 308.218 358.062 323.111 369.043 334.092C380.024 345.073 394.917 351.242 410.446 351.242C425.976 351.242 440.869 345.073 451.85 334.092Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorruption);
export default __webpack_public_path__ + "static/media/corruption.3d5fdeb208313447fa929e14a99f993d.svg";
export { ForwardRef as ReactComponent };